import { gql } from '@apollo/client';

export default gql`
  mutation updatePayments($bookingReference: String!, $payments: [UpdatePaymentInput]) {
    updatePayments(bookingReference: $bookingReference, payments: $payments) {
      reference
    }
  }
`;
